<template>
  <div class="photo-modal">
    <img class="photo" :src="photo.url" :alt="photo.title" />
    <button class="back" @click="$emit('close')">
      <i class="fa fa-arrow-left"></i>
    </button>
    <button v-if="count > 0" class="prev" @click="$emit('prev')">
      <i class="fa fa-angle-left"></i>
    </button>
    <button v-if="count < total - 1" class="next" @click="$emit('next')">
      <i class="fa fa-angle-right"></i>
    </button>
    <div class="title">{{ photo.title }}</div>
    <div class="number">{{ count + 1 }}/{{ total }}</div>
  </div>
</template>

<script>
export default {
  name: 'PhotoModal',
  props: {
    photo: { type: Object, required: true },
    count: { type: Number, required: true },
    total: { type: Number, required: true },
  },
  emits: ['close', 'prev', 'next'],
}
</script>
